import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Stack,
  HStack,
  Heading,
  useToast,
  IconButton,
  Tooltip,
  Button,
  CircularProgress,
} from "@chakra-ui/react";
import { MdAddCircleOutline, MdOutlineCreate } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import EliminarSandvan from "./components/sandvans/EliminarSandvan";
import { getSanvan } from "../operaciones/helpers/api.helper";
import { useSelector } from "react-redux";

const Sandvan = () => {
  const [sandvans, setSandvans] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();
  const { user } = useSelector((state) => state.user);

  const initData = async () => {
    setLoading(true);
    let res = await getSanvan();
    if (res.status === 200) {
      setSandvans(res.data);
    } else {
      toast({
        title: "Error",
        description: "Error al cargar las plantas",
        duration: 3000,
        isClosable: true,
        status: "error",
      });
    }
    setLoading(false);
  };

  const loadingtable = () => {
    return (
      <HStack w="100%" placeContent="center">
        <CircularProgress isIndeterminate color="brand.naranja" />
      </HStack>
    );
  };
  useEffect(() => {
    initData();
  }, []);

  return (
    <Stack w="100%" h="xl">
      <HStack w="100%" justifyContent="space-between" px={5}>
        <Heading
          fontWeight="medium"
          size="xl"
          fontFamily="fonts.title"
          color="brand.gris_primario"
        >
          Sandvan
        </Heading>
        {(user.idRol === "admin" ||
          user.idRol === "coorOp" ||
          user.idRol === "usuarioIT") && (
          <Button
            size="sm"
            variant="outline"
            border="1px solid #FF8200"
            leftIcon={<MdAddCircleOutline fontSize="20px" />}
            color="brand.naranja"
            onClick={() => navigate("/inventario/sandvan/nuevo")}
            _hover={{ bg: "brand.naranja", color: "white" }}
          >
            Nuevo sandvan
          </Button>
        )}
      </HStack>
      {loading && loadingtable()}
      {!loading && sandvans.length > 0 && (
        <TableContainer>
          <Table size="sm" h="max-content" variant="simple">
            <Thead>
              <Tr borderBottom="2px solid black">
                <Th>ID SandVan</Th>
                <Th>SET</Th>
                <Th>Activo/Inactivo</Th>
                {(user.idRol === "admin" ||
                  user.idRol === "coorOp" ||
                  user.idRol === "usuarioIT") && (
                  <Th textAlign={"center"}>Acciones</Th>
                )}
              </Tr>
            </Thead>
            <Tbody>
              {sandvans.map((sandvan) => (
                <Tr key={sandvan.idSandVan}>
                  <Td>{sandvan.codigoSandVan}</Td>
                  <Td>{sandvan.setSandVan === "set1" ? "SET 1" : "SET 2"}</Td>
                  <Td
                    color={sandvan.estadoSandVan === "activo" ? "green" : "red"}
                  >
                    {sandvan.estadoSandVan === "activo" ? "Activo" : "Inactivo"}
                  </Td>
                  {(user.idRol === "admin" ||
                    user.idRol === "coorOp" ||
                    user.idRol === "usuarioIT") && (
                    <Td textAlign={"center"}>
                      <Tooltip label="Editar SandVan">
                        <IconButton
                          variant="link"
                          icon={<MdOutlineCreate fontSize="20px" />}
                          isDisabled={user.idRol === "usuarioIT"}
                          onClick={() =>
                            navigate(
                              `/inventario/sandvan/editar/${sandvan.idSandVan}`
                            )
                          }
                          _hover={{ color: "brand.naranja" }}
                        />
                      </Tooltip>
                      <EliminarSandvan
                        sandvan={sandvan}
                        initData={initData}
                        user={user}
                      />
                    </Td>
                  )}
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      )}
      {!loading && sandvans.length < 1 && (
        <Heading textAlign={"center"} size={"md"}>
          No hay datos para mostrar
        </Heading>
      )}
    </Stack>
  );
};

export default Sandvan;
